import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { belongsTo, attr, hasMany } from '@ember-data/model';
import { formatEuro } from 'beebee-base/lib/utility';
import { cached } from '@glimmer/tracking';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25;
let InvoiceproductModel = (_dec = belongsTo('invoice', {
  inverse: 'invoiceproducts',
  async: false
}), _dec2 = attr('number'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('number', {
  currency: true
}), _dec6 = attr('number'), _dec7 = attr('string'), _dec8 = attr('number', {
  currency: true
}), _dec9 = attr('number', {
  defaultValue: 100
}), _dec0 = attr('string'), _dec1 = attr('number'), _dec10 = attr('number'), _dec11 = attr('number'), _dec12 = attr('boolean'), _dec13 = attr('boolean'), _dec14 = belongsTo('contact', {
  inverse: null,
  async: false
}), _dec15 = belongsTo('product', {
  inverse: null,
  async: false
}), _dec16 = belongsTo('project', {
  inverse: null,
  async: false
}), _dec17 = belongsTo('event', {
  inverse: null,
  async: false
}), _dec18 = attr('number'), _dec19 = attr('string'), _dec20 = attr('boolean'), _dec21 = attr('string'), _dec22 = hasMany('invoiceproduct_tax', {
  inverse: null,
  async: false
}), _dec23 = belongsTo('category', {
  inverse: null,
  async: false
}), _dec24 = belongsTo('sub_category', {
  inverse: null,
  async: false
}), _dec25 = attr('boolean', {
  defaultValue: false
}), _class = class InvoiceproductModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "invoice", _descriptor, this);
    _initializerDefineProperty(this, "rank", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "description", _descriptor4, this);
    _initializerDefineProperty(this, "price", _descriptor5, this);
    _initializerDefineProperty(this, "qta", _descriptor6, this);
    _initializerDefineProperty(this, "unit", _descriptor7, this);
    _initializerDefineProperty(this, "importo", _descriptor8, this);
    _initializerDefineProperty(this, "iva_det", _descriptor9, this);
    _initializerDefineProperty(this, "codice", _descriptor0, this);
    _initializerDefineProperty(this, "larghezza", _descriptor1, this);
    _initializerDefineProperty(this, "profondita", _descriptor10, this);
    _initializerDefineProperty(this, "altezza", _descriptor11, this);
    _initializerDefineProperty(this, "bollo_imponibile", _descriptor12, this);
    _initializerDefineProperty(this, "is_bollo", _descriptor13, this);
    _initializerDefineProperty(this, "contact", _descriptor14, this);
    _initializerDefineProperty(this, "product", _descriptor15, this);
    _initializerDefineProperty(this, "project", _descriptor16, this);
    _initializerDefineProperty(this, "event", _descriptor17, this);
    _initializerDefineProperty(this, "iva_rate", _descriptor18, this);
    _initializerDefineProperty(this, "iva_natura", _descriptor19, this);
    _initializerDefineProperty(this, "ritenuta", _descriptor20, this);
    _initializerDefineProperty(this, "sdi_field", _descriptor21, this);
    _initializerDefineProperty(this, "invoiceproduct_taxes", _descriptor22, this);
    _initializerDefineProperty(this, "category", _descriptor23, this);
    _initializerDefineProperty(this, "sub_category", _descriptor24, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor25, this);
  }
  get iva_det_imp() {
    const importo = this.importo ?? 0;
    const ivaDetraibilePercent = this.iva_det ?? 100;
    const ivaRatePercent = this.iva_rate ?? 0;
    const isPrezzoLordo = this.invoice?.lordo ?? false;
    const grossDivisor = 1 + ivaRatePercent / 100;
    const ivaTotale = isPrezzoLordo ? grossDivisor !== 0 ? importo - importo / grossDivisor : 0 : importo * (ivaRatePercent / 100);
    const importoIvaDetraibile = ivaTotale * (ivaDetraibilePercent / 100);
    return formatEuro(importoIvaDetraibile);
  }
  get rand_id() {
    return `rid-${Math.random().toString(36).substring(2, 8)}`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "invoice", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "qta", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "unit", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "importo", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "iva_det", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "iva_det_imp", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "iva_det_imp"), _class.prototype), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "codice", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "larghezza", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "profondita", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "altezza", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "bollo_imponibile", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "is_bollo", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "product", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "project", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "event", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "iva_rate", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "iva_natura", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "ritenuta", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "sdi_field", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "invoiceproduct_taxes", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "category", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "sub_category", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "rand_id", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "rand_id"), _class.prototype), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { InvoiceproductModel as default };
//# sourceMappingURL=invoiceproduct.js.map
